import { ReservedSlotsCalendar } from "./ReservedSlotsCalendar";

export const reservedSlotsRoutes = [
    {
        path: "/reserved-slots",
        element: <ReservedSlotsCalendar />,
    },
];

